import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  procedimentoApenasHospitalDia: boolean,
}

interface ProcedimentoApenasHospitalDia {
  procedimentoId: string,
  codigo: string,
  procedimentoDescricao: string,
  convenioId: string,
  convenioDescricao: string,
  hospitalDia: boolean,
  status?: 'Ativo' | 'Removido',
}

interface Procedimento {
  id: string | null,
  codigo: string,
  descricao: string | null,
  porte: string | null,
  quantidadeAuxiliares: number,
  status: string,
  temLateralidade: boolean,
  tipo: string | null,
  hospitalId: string,
  hisId: string,
  tecnicasDoProcedimento: TecnicaDoProcedimento[],
}

interface TecnicaDoProcedimento {
  id: string,
  descricao: string,
}

interface Convenio {
  id: string,
  nome: string,
  particular: boolean,
  status: string,
  codigoOperadora: string,
  hospitalRealizaCotacao: boolean,
  convenioFazCodificacaoDeOpme: boolean,
  registroANS: string,
  tempoParaAutorizacao: null,
  hospitalId: string,
  hisId?: string,
  prazoEmDiasParaTriagem: number,
  prazoMaximoEmDiasParaAgendamento: number,
}

@Module({ namespaced: true, name: 'SuporteProcedimentosApenasHospitalDiaStore' })
export default class SuporteProcedimentosApenasHospitalDiaStore extends VuexModule {
  public hospitalId: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    procedimentoApenasHospitalDia: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  /** Procedimentos Apenas Hospital Dia */
  private paginationProcedimentosApenasHospitalDiaDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  public paginationProcedimentosApenasHospitalDia: DataTablePagination = { ...this.paginationProcedimentosApenasHospitalDiaDefault }

  get procedimentosApenasHospitalDiaPaginationDefault() {
    return this.paginationProcedimentosApenasHospitalDia
  }

  private procedimentosApenasHospitalDiaDefault: ProcedimentoApenasHospitalDia[] = []
  public procedimentosApenasHospitalDia: ProcedimentoApenasHospitalDia[] = [...this.procedimentosApenasHospitalDiaDefault]
  private procedimentoApenasHospitalDiaDefault: ProcedimentoApenasHospitalDia = {
    procedimentoId: '',
    codigo: '',
    procedimentoDescricao: '',
    convenioId: '',
    convenioDescricao: '',
    hospitalDia: true,
  }

  public procedimentoApenasHospitalDia: ProcedimentoApenasHospitalDia = { ...this.procedimentoApenasHospitalDiaDefault }

  public searchProcedimentoApenasHospitalDia: string = ''

  @Mutation
  setSearchProcedimentoApenasHospitalDia(value: string) {
    this.searchProcedimentoApenasHospitalDia = value
  }

  @Mutation
  setPaginationProcedimentosApenasHospitalDia(val: DataTablePagination) {
    this.paginationProcedimentosApenasHospitalDia = val
  }

  @Mutation
  setProcedimentosApenasHospitalDia(value: ProcedimentoApenasHospitalDia[]) {
    this.procedimentosApenasHospitalDia = value
  }

  @Mutation
  clearProcedimentosApenasHospitalDia() {
    this.procedimentosApenasHospitalDia = [...this.procedimentosApenasHospitalDiaDefault]
  }

  @Mutation
  setProcedimentoApenasHospitalDia(value: ProcedimentoApenasHospitalDia) {
    this.procedimentoApenasHospitalDia = value
  }

  @Mutation
  clearProcedimentoApenasHospitalDia() {
    this.procedimentoApenasHospitalDia = { ...this.procedimentoApenasHospitalDiaDefault }
  }

  @Action
  async getProcedimentosApenasHospitalDiaPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationProcedimentosApenasHospitalDia.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationProcedimentosApenasHospitalDia.rowsPerPage,
        searchText: this.searchProcedimentoApenasHospitalDia,
      }

      const request = await Apis.Agendamento.SuporteApi.getAllProcedimentosApenasHospitalDiaByHospital(params)

      if (request.success) {
        this.context.commit('setProcedimentosApenasHospitalDia', request.data.procedimentosApenasHospitalDia as ProcedimentoApenasHospitalDia[] || [])
        this.context.commit('setPaginationProcedimentosApenasHospitalDia', {
          descending: false,
          page: pagination.page || this.paginationProcedimentosApenasHospitalDia.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationProcedimentosApenasHospitalDia.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationProcedimentosApenasHospitalDia.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setProcedimentosApenasHospitalDia', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertProcedimentoApenasHospitalDia() {
    const params: ProcedimentoApenasHospitalDia = this.procedimentoApenasHospitalDia
    Object.entries(params).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete params[key]
    })

    const request = await Apis.Agendamento.SuporteApi.upsertProcedimentoApenasHospitalDia({ ...params, hospitalId: this.hospitalId })
    return request
  }

  /** Procedimentos & Convênios */
  public convenios: Convenio[] = []
  public procedimentos: Procedimento[] = []

  @Mutation
  setProcedimentos(value: Procedimento[]) {
    this.procedimentos = value
  }

  @Mutation
  clearProcedimentos() {
    this.procedimentos = []
  }

  @Mutation
  setConvenios(value: Convenio[]) {
    this.convenios = value
  }

  @Mutation
  clearConvenios() {
    this.convenios = []
  }

  @Action
  async getProcedimentos() {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        page: 1,
        total: 500,
        // total: 32767,
        searchText: '',
      }

      const request = await Apis.Agendamento.SuporteApi.getProcedimentoPagedSearch(params)
      if (request.success) this.context.commit('setProcedimentos', request.data.procedimentos as Procedimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setProcedimentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getConvenios() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllConvenio(this.hospitalId)
      if (request.success) this.context.commit('setConvenios', request.data as Convenio[] || [])
      return request
    } catch (error) {
      this.context.commit('setConvenios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
